import Layout from "components/layout/Layout";

export default function About() {
  return (
    <Layout
      headerStyle={1}
      footerStyle={1}
      breadcrumbTitle={
        <>
          About <span>Us</span>
        </>
      }
    >
      <div>
        <section className="job-details-area pb-150">
          <div className="container">
            <div className="row">
              <div className="col-lg-10">
                <div className="job-details-content">
                  <div className="job-qualifications">
                    <p className="info-one">
                      At BodyLytiX, we believe fitness and wellness are more than a journey—they're a science. Our mission is to empower you with personalized, data-driven insights that bridge the gap between knowledge and action. Using cutting-edge technology and analytics, we help you unlock your potential, one metric at a time.
                    </p>

                    <div className="job-details-list-wrap">
                      <h2 className="title-two">
                        Who We Are
                      </h2>
                      <p className="info-one">
                        BodyLytiX was born out of a passion for fitness, technology, and the desire to make health tracking smarter and more intuitive. Our team comprises fitness enthusiasts, tech innovators, and wellness advocates who are dedicated to revolutionizing the way you understand and achieve your fitness goals. We’re here to bridge the gap between data and action, providing you with the tools you need to train smarter, recover better, and live healthier.
                      </p>
                    </div>

                    <div className="job-details-list-wrap">
                      <h2 className="title-two">
                        What We Do
                      </h2>
                      <p className="info-one">
                        We combine the power of AI and wearable technology to deliver insights that matter. Whether you’re training for your first marathon, building strength, or simply striving for a healthier lifestyle, BodyLytiX gives you the data and guidance you need to make every effort count. From tracking your performance to offering personalized recommendations, we make fitness accessible, actionable, and measurable.
                      </p>
                    </div>

                    <div className="job-details-list-wrap">
                      <h2 className="title-two">
                        Why BodyLytiX?
                      </h2>
                      <ul>
                        <li>
                          <strong>Personalized Insights: </strong>
                          Every body is unique, and so is our approach. We analyze your fitness data to deliver insights tailored to your goals.
                        </li>
                        <li>
                          <strong>AI-Powered Analytics: </strong>
                          Our advanced algorithms help you understand your progress and optimize your performance.
                        </li>
                        <li>
                          <strong>Community Focused: </strong>
                          Whether you create your own "Coach" or explore others shared by our community, BodyLytiX fosters collaboration and shared success.
                        </li>
                        <li>
                          <strong>Holistic Health: </strong>
                          We go beyond fitness, incorporating mental wellness, supplementation tracking, and recovery into your health plan.
                        </li>
                      </ul>
                    </div>

                    <div className="job-details-list-wrap">
                      <h2 className="title-two">
                        Our Vision
                      </h2>
                      <p className="info-one">
                        To become the trusted partner for individuals seeking to achieve their best selves through innovative fitness and wellness solutions. At BodyLytiX, we’re not just building tools; we’re building a community of motivated individuals striving to lead healthier, happier lives.
                      </p>
                    </div>

                    <div className="job-details-list-wrap">
                      <h2 className="title-two">
                        Join Us
                      </h2>
                      <p className="info-one">
                        Join the BodyLytiX movement today and take the first step toward a more data-driven, personalized fitness experience. Together, let’s redefine what’s possible for your body and mind.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* about-area */}
        {/* <section className="inner-about-area pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="inner-about-img">
                  <img src="assets/img/images/about.jpg" alt="about" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="inner-about-content">
                  <h2 className="title wow fadeInUp" data-wow-delay=".2s">
                    Content Creation with AI
                  </h2>
                  <div className="content-bottom">
                    <p>
                      At Dex.ai , we use artificial intelligence to generate
                      high-quality content at scale. Our platform analyzes vast
                      amounts of data using natural language processing and
                      machine learning algorithms to create accurate, compelling
                      content. Whether you need product descriptions, social
                      media posts, or blog articles, our AI-powered solutions
                      save time, reduce costs, and deliver measurable results.
                      Let us show you how our technology can transform your
                      content strategy and help you achieve your business goals.
                    </p>
                    <ul className="list-wrap">
                      <li>
                        <i className="far fa-check" />
                        Automated Content Creation
                      </li>
                      <li>
                        <i className="far fa-check" />
                        We Focus on Quantity Well Organised Content.
                      </li>
                      <li>
                        <i className="far fa-check" />
                        Multilingual Support
                      </li>
                      <li>
                        <i className="far fa-check" />
                        Professional Team with 10+ Experience.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* about-area-end */}
        {/* team-area */}
        {/* <section className="team-area pb-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title-four text-center mb-60">
                  <h2 className="title wow fadeInUp" data-wow-delay=".2s">
                    Core Members
                  </h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-6">
                <div className="team-item">
                  <div className="team-thumb">
                    <img src="assets/img/team/team_img01.jpg" alt="" />
                    <div className="team-hidden-content">
                      <h4 className="title">Jack O'Halloran</h4>
                      <p>
                        A Co-Founder is someone who helps establish a company
                        from the ground up, often sharing the vision and
                        responsibilities of the business with one or more other
                        individuals. Co-Founders bring unique skills and
                        expertise to the table, which can complement each other
                        and drive the company forward.
                      </p>
                    </div>
                  </div>
                  <div className="team-content">
                    <div className="team-info">
                      <h4 className="title">Jack O'Halloran</h4>
                      <span>Co-Founder / CEO</span>
                    </div>
                    <div className="team-social">
                      <ul className="list-wrap">
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin-in" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="team-item">
                  <div className="team-thumb">
                    <img src="assets/img/team/team_img02.jpg" alt="" />
                    <div className="team-hidden-content">
                      <h4 className="title">Alex Sheverdin</h4>
                      <p>
                        A Co-Founder is someone who helps establish a company
                        from the ground up, often sharing the vision and
                        responsibilities of the business with one or more other
                        individuals. Co-Founders bring unique skills and
                        expertise to the table, which can complement each other
                        and drive the company forward.
                      </p>
                    </div>
                  </div>
                  <div className="team-content">
                    <div className="team-info">
                      <h4 className="title">Alex Sheverdin</h4>
                      <span>Co-Founder / CEO</span>
                    </div>
                    <div className="team-social">
                      <ul className="list-wrap">
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin-in" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-10">
                <div className="team-item-two">
                  <div className="team-thumb-two">
                    <img src="assets/img/team/team_img03.jpg" alt="" />
                  </div>
                  <div className="team-content-two">
                    <div className="team-info">
                      <h4 className="title">Anastasia Yatsun</h4>
                      <span>Software Engineer</span>
                    </div>
                    <div className="team-social">
                      <ul className="list-wrap">
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin-in" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-10">
                <div className="team-item-two">
                  <div className="team-thumb-two">
                    <img src="assets/img/team/team_img04.jpg" alt="" />
                  </div>
                  <div className="team-content-two">
                    <div className="team-info">
                      <h4 className="title">Ben Miller</h4>
                      <span>UI/UX Designer</span>
                    </div>
                    <div className="team-social">
                      <ul className="list-wrap">
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin-in" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-10">
                <div className="team-item-two">
                  <div className="team-thumb-two">
                    <img src="assets/img/team/team_img05.jpg" alt="" />
                  </div>
                  <div className="team-content-two">
                    <div className="team-info">
                      <h4 className="title">Rob Lubow</h4>
                      <span>QA Engineer</span>
                    </div>
                    <div className="team-social">
                      <ul className="list-wrap">
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin-in" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* team-area-end */}
        {/* counter-area */}
        {/* <section className="counter-area-three pb-160">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="counter-content">
                  <div className="section-title-four mb-40">
                    <h2 className="title wow fadeInLeft" data-wow-delay=".2s">
                      AI can write content just like humans can
                    </h2>
                  </div>
                  <p>
                    By using Natural Language Processing (NLP) techniques, AI
                    can understand the context, tone, and intent of a given
                    piece of content, and produce written output that's relevant
                    and engaging. This technology is especially useful for
                    generating large volumes of content quickly and accurately,
                    which can save businesses a significant amount of time and
                    resources.
                  </p>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="counter-item-wrap-three">
                  <ul className="list-wrap">
                    <li>
                      <div className="counter-item-three">
                        <h2 className="count">
                          <CountUp
                            end={1}
                            suffix="M"
                            duration={5}
                            enableScrollSpy
                            scrollSpyDelay={5}
                          />
                        </h2>
                        <p>Our Top Clients</p>
                      </div>
                    </li>
                    <li>
                      <div className="counter-item-three">
                        <h2 className="count">
                          <CountUp
                            end={50}
                            suffix="M"
                            duration={5}
                            enableScrollSpy
                            scrollSpyDelay={5}
                          />
                        </h2>
                        <p>Social Media Platforms</p>
                      </div>
                    </li>
                    <li>
                      <div className="counter-item-three">
                        <h2 className="count">
                          <CountUp
                            end={4}
                            suffix="K"
                            duration={5}
                            enableScrollSpy
                            scrollSpyDelay={5}
                          />
                        </h2>
                        <p>Powerful AI Tools</p>
                      </div>
                    </li>
                    <li>
                      <div className="counter-item-three">
                        <h2 className="count">
                          <CountUp
                            end={10}
                            suffix="M"
                            duration={5}
                            enableScrollSpy
                            scrollSpyDelay={5}
                          />
                        </h2>
                        <p>Our Readers</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* counter-area-end */}
      </div>
    </Layout>
  );
}
